module.exports = __webpack_public_path__ + "static/beautiful-ruins-44079c2d600f2d22c52efb41095d5645.jpg";